import React, { useState, useEffect, useReducer } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Tabs, Tab, Box } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import SubscriptionModal from "../../components/SubscriptionModal";
import TabPanel from "../../components/TabPanel";
import SubscriptionContent from "../Subscription/SubscriptionContent";
// import InvoicesManager from "../../components/InvoicesManager"; // TODO: Componente no existe aún
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import toastError from "../../errors/toastError";

import moment from "moment";

const reducer = (state, action) => {
  if (action.type === "LOAD_INVOICES") {
    const invoices = action.payload;
    const newUsers = [];

    invoices.forEach((user) => {
      const userIndex = state.findIndex((u) => u.id === user.id);
      if (userIndex !== -1) {
        state[userIndex] = user;
      } else {
        newUsers.push(user);
      }
    });

    return [...state, ...newUsers];
  }

  if (action.type === "UPDATE_USERS") {
    const user = action.payload;
    const userIndex = state.findIndex((u) => u.id === user.id);

    if (userIndex !== -1) {
      state[userIndex] = user;
      return [...state];
    } else {
      return [user, ...state];
    }
  }

  if (action.type === "DELETE_USER") {
    const userId = action.payload;

    const userIndex = state.findIndex((u) => u.id === userId);
    if (userIndex !== -1) {
      state.splice(userIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  tabsContainer: {
    backgroundColor: theme.palette.background.paper,
    "& .MuiTabs-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider || (theme.mode === 'dark' ? '#374151' : '#e0e0e0')}`,
    },
    "& .MuiTabs-flexContainer": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
      "&.Mui-selected": {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  paper: {
    ...theme.scrollbarStyles,
    overflowY: "scroll",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    width: "100%",
    maxHeight: "100%",
  },
}));

const Invoices = () => {
  const classes = useStyles();
  const { user } = React.useContext(AuthContext);
  const [tab, setTab] = useState("subscriptions");

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  // searchParam se mantiene para compatibilidad con la API aunque no hay campo de búsqueda visible
  const [searchParam] = useState("");

  const [invoices, dispatch] = useReducer(reducer, []);
  const [storagePlans, setStoragePlans] = React.useState([]);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);


  const handleOpenContactModal = (invoices) => {
    setStoragePlans(invoices);
    setSelectedContactId(null);
    setContactModalOpen(true);
  };


  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };
  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchInvoices = async () => {
        try {
          const { data } = await api.get("/invoices/all", {
            params: { searchParam, pageNumber },
          });
          dispatch({ type: "LOAD_INVOICES", payload: data });
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchInvoices();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);


  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };
  const rowStyle = (record) => {
    const hoje = moment(moment()).format("DD/MM/yyyy");
    const vencimento = moment(record.dueDate).format("DD/MM/yyyy");
    var diff = moment(vencimento, "DD/MM/yyyy").diff(moment(hoje, "DD/MM/yyyy"));
    var dias = moment.duration(diff).asDays();    
    if (dias < 0 && record.status !== "paid") {
      return { backgroundColor: "#ffbcbc9c" };
    }
  };

  const rowStatus = (record) => {
    const hoje = moment(moment()).format("DD/MM/yyyy");
    const vencimento = moment(record.dueDate).format("DD/MM/yyyy");
    var diff = moment(vencimento, "DD/MM/yyyy").diff(moment(hoje, "DD/MM/yyyy"));
    var dias = moment.duration(diff).asDays();    
    const status = record.status;
    if (status === "paid") {
      return i18n.t("financial.status.paid");
    }
    if (dias < 0) {
      return i18n.t("financial.status.overdue");
    } else {
      return i18n.t("financial.status.open");
    }

  }

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <MainContainer className={classes.root}>
      <SubscriptionModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        Invoice={storagePlans}
        contactId={selectedContactId}
      />
      <MainHeader>
        <Title>{i18n.t("financial.title")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        <div className={classes.tabsContainer}>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            onChange={handleTabChange}
          >
            <Tab label="Suscripciones" value="subscriptions" />
            <Tab label="Facturas" value="invoices" />
            {user?.profile === 'admin' && <Tab label="Gestión" value="management" />}
          </Tabs>
        </div>
        <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <TabPanel className={classes.container} value={tab} name="subscriptions" style={{ flex: 1, overflow: 'auto' }}>
            <SubscriptionContent />
          </TabPanel>
          <TabPanel className={classes.container} value={tab} name="invoices" style={{ flex: 1, overflow: 'auto' }}>
            <Paper
              className={classes.mainPaper}
              variant="outlined"
              onScroll={handleScroll}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{i18n.t("financial.table.id")}</TableCell>
                    <TableCell align="center">{i18n.t("financial.table.details")}</TableCell>
                    <TableCell align="center">{i18n.t("financial.table.value")}</TableCell>
                    <TableCell align="center">{i18n.t("financial.table.dueDate")}</TableCell>
                    <TableCell align="center">{i18n.t("financial.table.status")}</TableCell>
                    <TableCell align="center">{i18n.t("financial.table.action")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <>
                    {invoices.map((invoices) => (
                      <TableRow style={rowStyle(invoices)} key={invoices.id}>
                        <TableCell align="center">{invoices.id}</TableCell>
                        <TableCell align="center">{invoices.detail}</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }} align="center">{invoices.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</TableCell>
                        <TableCell align="center">{moment(invoices.dueDate).format("DD/MM/YYYY")}</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }} align="center">{rowStatus(invoices)}</TableCell>
                        <TableCell align="center">
                          {rowStatus(invoices) !== i18n.t("financial.status.paid") ?
                            <Button
                              size="small"
                              variant="outlined"
                              color="secondary"
                              onClick={() => handleOpenContactModal(invoices)}
                            >
                              {i18n.t("financial.buttons.pay")}
                            </Button> :
                            <Button
                              size="small"
                              variant="outlined" 
                            >
                              {i18n.t("financial.buttons.paid")}
                            </Button>}
                        </TableCell>
                      </TableRow>
                    ))}
                    {loading && <TableRowSkeleton columns={4} />}
                  </>
                </TableBody>
              </Table>
            </Paper>
          </TabPanel>
          {/* TODO: InvoicesManager component no existe aún
          {user?.profile === 'admin' && (
            <TabPanel className={classes.container} value={tab} name="management" style={{ flex: 1, overflow: 'auto' }}>
              <InvoicesManager />
            </TabPanel>
          )}
          */}
        </Box>
      </Paper>
    </MainContainer>
  );
};

export default Invoices;
